import * as React from 'react';
import { useTranslation } from 'react-i18next';

import './style.scss';

const SkipToMainContentLink: React.FC = () => {
  const { t } = useTranslation();

  return (
    <a href="#main" className="SkipToMainContentLink">{t('general.skip_to_main_content')}</a>
  );
};

export default SkipToMainContentLink;
